/** localStorage keys and timing for the occasional Care Dock prompt. */

export const CARE_DOCK_SUCCESS_COUNT_KEY = "vortixy.careDock.successCount";
export const CARE_DOCK_LAST_SHOWN_AT_KEY = "vortixy.careDock.lastShownAt";
export const CARE_DOCK_COOLDOWN_UNTIL_KEY = "vortixy.careDock.cooldownUntil";

/** Custom event fires after a successful AI review. */
export const CARE_DOCK_SUCCESS_EVENT = "vortixy:care-dock-success";

export const CARE_DOCK_SUCCESS_THRESHOLD = 3;
export const CARE_DOCK_RESHOW_AFTER_MS = 24 * 60 * 60 * 1000;
export const CARE_DOCK_DISMISS_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;
export const CARE_DOCK_CTA_COOLDOWN_MS = 14 * 24 * 60 * 60 * 1000;
